function dictionaryApiFactory(storefrontApiClient) {
  const dictionaryApi = {
    getDictionary(categoryId, params) {
      return storefrontApiClient.get(`/dictionary/${categoryId}`, {
        params,
      });
    },
    getDictionaryDetail(categoryId, keyword) {
      return storefrontApiClient.get(`/dictionary/${categoryId}/keyword/${encodeURI(keyword)}`, {
      });
    },
  };

  return dictionaryApi;
}

export default dictionaryApiFactory;
